import { Outlet, createFileRoute } from '@tanstack/react-router';

/** Layout for `/resetpassword/$guid` and `/resetpassword/$guid/$channel`. */
export const Route = createFileRoute('/resetpassword')({
  component: ResetPasswordLayout,
});

function ResetPasswordLayout() {
  return <Outlet />;
}
